import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isHeader"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import Box from 'components/Box';
import { useTableContext } from './TableContext';
import TableCell from './TableCell';
import { Wrapper as ColumnHeaderCell } from './TableColumnHeader';
import { jsx as _jsx } from "react/jsx-runtime";
var TableCheckboxCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isHeader = _ref.isHeader,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTableContext = useTableContext(),
    mobileViewBreakpoint = _useTableContext.mobileViewBreakpoint;
  if (isHeader) {
    return /*#__PURE__*/_jsx(ColumnHeaderCell, _objectSpread(_objectSpread({}, otherProps), {}, {
      isCheckbox: true,
      ref: ref,
      scope: "col",
      width: 20,
      children: /*#__PURE__*/_jsx(Box, {
        display: "flex",
        children: children
      })
    }));
  }
  return /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({
    isCheckbox: true
  }, otherProps), {}, {
    ref: ref,
    children: /*#__PURE__*/_jsx(Box, {
      display: "flex",
      alignItems: ['top', 'center'],
      height: "100%",
      breakpoints: mobileViewBreakpoint,
      children: children
    })
  }));
});
TableCheckboxCell.displayName = 'TableCheckboxCell';
export default TableCheckboxCell;